/// <reference types="jquery" />
/* to import styles for user satisfaction modal */
import "./css/satisfaction.css";
// import bootstrap from "bootstrap";
/* For user satisfaction modal */
// let my_modal = <HTMLElement>document.getElementById("modal-user-satisfaction");
// let user_satisfaction_modal = new bootstrap.Modal(
//   $("#modal-user-satisfaction")
// );
// let user_satisfaction_modal = (<unknown>(
//   document.getElementById("modal-user-satisfaction")
// )) as bootstrap.Modal;
var submit_user_comment_btn = (document.getElementById("submit-usr-comment"));
var _init_user_satisfaction = function () {
    $("#modal-user-satisfaction").on("show.bs.modal", initModalValues);
    submit_user_comment_btn.addEventListener("click", submitUserComment);
};
var changeEmoticonAspect = function () {
    /* reset all font-weights */
    $("i.satisfaction").css({ "font-weight": 400 });
    /* show which emoticon has been chosen */
    $('input[name="satisfaction"]:checked')
        .next("label")
        .find("i")
        .css({ "font-weight": 600 });
};
var initModalValues = function (event) {
    var button = $(event.relatedTarget); // Button that triggered the modal
    // let userid = button.data("userid");
    var md_source = button.data("source");
    var radio_selected = button.data("selected");
    $("#modal-user-satisfaction").find("#md-source").val(md_source);
    initRadioInput(radio_selected);
    $('input[name="satisfaction"]').on("change", changeEmoticonAspect);
    // $("#modal-user-satisfaction").find("#md-userid").val(userid);
};
var initRadioInput = function (btn) {
    // reset the radio input
    $('input:radio[name="satisfaction"]').removeAttr("checked");
    /* set the value in function of the button that has been used
     * NB this can be changed by the user before sending
     */
    if (btn === "md-happy") {
        $("input:radio[name='satisfaction']:nth(0)").attr("checked", "checked");
    }
    else if (btn === "md-neutral") {
        $("input:radio[name='satisfaction']:nth(1)").attr("checked", "checked");
    }
    else if (btn === "md-angry") {
        $("input:radio[name='satisfaction']:nth(2)").attr("checked", "checked");
    }
    changeEmoticonAspect();
};
var submitUserComment = function () {
    var params = {
        data: {
            userid: $("#md-userid").val(),
            source: $("#md-source").val(),
            satisfaction: $('input[name="satisfaction"]:checked').val(),
            comment: $("#md-comment").val(),
        },
    };
    $.ajax({
        url: "/fr/accounts/satisfaction/add/",
        type: "POST",
        data: params.data,
        // handle a successful response
        success: function (json) {
            // log the returned json to the console
            console.log(json);
            //Section.modalInfo("Confirmation", json.result);
        },
        // handle a non-successful response
        error: function (xhr, errmsg, err) {
            // provide a bit more info about the error to the console
            console.log(xhr.status + ": " + xhr.responseText);
        },
    });
    // FIXME once sent, reset the form
    // Hide the modal whatever is the result
    $("#modal-user-satisfaction").modal("hide");
};
/**
 * Une fois tout lu, on démarre
 */
_init_user_satisfaction();
